<template>
  <div v-show="visible">
    <div class="modal-backdrop fade in ivan-ent-backdrop" @click="visible=false" />
    <div class="modal fade in ivan-ent-modal" tabindex="-1" role="dialog" style="display:block">
      <div class="modal-dialog" role="document" :style="modalDialogStyle">
        <div class="modal-content">
          <div class="modal-header" style="padding: 8px 15px;">
            <button type="button" class="close" aria-label="Close" @click="visible=false">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title anCore-text-overflow" style="width:calc(100% - 50px);">选择企业</h4>
          </div>
          <div class="modal-body" :style="modalBodyStyle" v-loading="loading">
            <!-- 对齐 site List.html：pull-left 445 + divider-v + 右侧 -->
            <div class="clearfix" style="height:100%;">
              <div class="pull-left" style="height:100%; width:445px; padding-right:5px;">
                <div class="ent-list-toolbar">
                  <div class="has-feedback ent-list-search">
                    <input
                      class="form-control"
                      v-model="keyword"
                      placeholder="企业名称或编号"
                      @keyup.enter="search"
                    />
                    <span class="fa fa-search form-control-feedback" aria-hidden="true" />
                    <span class="sr-only">-</span>
                  </div>
                  <div class="ent-list-sort" title="排序规则">
                    <div class="input-group">
                      <span class="input-group-addon"><i class="fa fa-sort-alpha-asc" /></span>
                      <select class="form-control" style="padding-left:2px; padding-right:2px;" v-model="sortRule" @change="onSortChange">
                        <option value="ent_name">企业名称</option>
                        <option value="ent_code">企业编号</option>
                      </select>
                    </div>
                  </div>
                  <button type="button" class="btn btn-success btn-sm" @click.stop="openAddEnt">
                    <i class="fa fa-plus" />新增
                  </button>
                </div>
                <div style="overflow:auto; height:calc(100% - 44px); margin-bottom:0;">
          <ul class="list-group">
            <li
              v-for="row in sortedList"
              :key="row.id"
              class="list-group-item anCore-hover-panel"
              :class="{ active: current && current.id === row.id }"
              style="border-left:0; border-right:0; padding:8px 5px; position:relative;"
              @click="onRowClick(row)"
            >
              <div class="radio" style="margin:0">
                <label>
                  <input
                    type="radio"
                    name="entSelectedRadio"
                    :checked="current && current.id === row.id"
                    @click.stop="onRowClick(row)"
                  />
                  <span>{{ row.ent_name }}</span>
                </label>
              </div>
              <div class="small text-muted">{{ row.ent_code || '—' }}</div>
              <div class="anCore-hover-link" @click.stop>
                <button type="button" class="btn btn-sm btn-link" title="编辑" @click="startEditFromList(row)">
                  <i class="fa fa-edit" />
                </button>
                <button type="button" class="btn btn-sm btn-link" title="删除" @click="deleteEntFromList(row)">
                  <i class="fa fa-trash-o text-muted" />
                </button>
              </div>
            </li>
          </ul>
          <div v-if="!sortedList.length && !loading" class="text-center text-muted" style="padding:25px 0">没有数据</div>
        </div>
      </div>

              <div class="pull-left divider-v"></div>
              <div class="pull-left" style="height:100%; width:calc(100% - 445px - 10px);">
                <ul class="nav nav-tabs" role="tablist">
                  <li :class="{ active: tab === 'basic' }"><a href="javascript:;" @click.prevent="switchTab('basic')"><span>基本信息</span></a></li>
                  <li :class="{ active: tab === 'sites' }"><a href="javascript:;" @click.prevent="switchTab('sites')"><span>点位项目</span></a></li>
                  <li :class="{ active: tab === 'attachment' }"><a href="javascript:;" @click.prevent="switchTab('attachment')"><span>附件文档</span></a></li>
                  <li :class="{ active: tab === 'history' }"><a href="javascript:;" @click.prevent="switchTab('history')"><span>历史监测</span></a></li>
                </ul>
                <div style="height:calc(100% - 45px); overflow:auto; padding-left:15px;">
          <!-- 基本信息 -->
          <div v-show="tab === 'basic'">
            <div v-if="!current" class="text-center text-muted" style="padding:50px 0">没选择企业</div>
            <template v-else>
              <div class="clearfix ivan-ent-basic">
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">企业名称:</span><label>{{ current.ent_name }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">企业编号:</span><label>{{ current.ent_code || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">行政区域:</span><label>{{ regionText(current) }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">详细地址:</span><label>{{ current.address || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">邮编:</span><label>{{ current.zip_code || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">经度:</span><label>{{ current.longitude || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">纬度:</span><label>{{ current.latitude || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">行业:</span><label>{{ current.industry || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">联系人:</span><label>{{ current.linkman || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">联系电话:</span><label>{{ current.phone || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">传真:</span><label>{{ current.fax || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">邮箱:</span><label>{{ current.email || '—' }}</label></div>
                <div class="form-group col-sm-6"><span class="text-muted ivan-ent-label">备注:</span><label>{{ current.remark || '—' }}</label></div>
              </div>
            </template>
          </div>

          <!-- 点位项目（保留原能力） -->
          <div v-show="tab === 'sites'">
            <div v-if="!current" class="text-center text-muted" style="padding:50px 0">没选择企业</div>
            <template v-else>
              <div class="site-tab-toolbar">
                <el-button type="success" plain size="mini" icon="el-icon-plus" @click="openSiteAdd">+ 新增</el-button>
                <span class="site-year-label">方案日期</span>
                <el-select v-model="viewSchemeDate" size="mini" :clearable="false" placeholder="选择日期" style="width:130px" @change="onViewDateChange">
                  <el-option v-for="opt in schemeDateOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
                <el-dropdown v-if="copySourceYears.length" trigger="click" @command="copySitesFromYear">
                  <el-button type="text" size="mini" :loading="copySaving">从历史年复制</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="y in copySourceYears" :key="y" :command="y">复制 {{ yearLabel(y) }} → {{ viewSchemeYear }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <template v-if="siteImportEnabled">
                  <el-button type="text" size="mini" @click="selectAllSites">全选</el-button>
                  <el-button type="text" size="mini" @click="clearSiteSelection">取消全选</el-button>
                </template>
                <span class="site-tab-hint">{{ viewSchemeDate }} · {{ viewSchemeYear }} 年 · {{ sites.length }} 条{{ siteImportEnabled ? ' · 勾选后确定写入监测表' : '' }}</span>
              </div>
              <el-table
                ref="siteTable"
                :data="sites"
                size="mini"
                max-height="360"
                empty-text="该年没有点位信息，可新增或从历史年复制"
                row-key="id"
                @row-dblclick="pickSite"
                @selection-change="onSiteSelectionChange"
              >
                <el-table-column v-if="siteImportEnabled" type="selection" width="42" align="center" :selectable="() => true" />
                <el-table-column label="区域/水体" min-width="110" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.region_name || '—' }}</template>
                </el-table-column>
                <el-table-column prop="site_name" label="点位/断面" min-width="120" show-overflow-tooltip />
                <el-table-column prop="item_names" label="监测项目" min-width="120" show-overflow-tooltip />
                <el-table-column label="检测频次" width="100" align="center" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ siteFreqLabel(row) }}</template>
                </el-table-column>
                <el-table-column label="方案日期" width="96" align="center">
                  <template slot-scope="{ row }">{{ formatSchemeYearDisplay(row.scheme_year) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="88" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click.stop="openSiteEdit(row)">编辑</el-button>
                    <el-button type="text" size="mini" class="danger-link" @click.stop="deleteSite(row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="sites.length && siteImportEnabled" class="site-hint">已勾选 {{ selectedSites.length }} / {{ sites.length }} 条，确定后将写入监测表</div>
              <div v-else-if="sites.length" class="site-hint">双击行可单条带入监测条目</div>
            </template>
          </div>

          <!-- 附件文档（占位，对齐 Ivan Tab） -->
          <div v-show="tab === 'attachment'">
            <div v-if="!current" class="text-center text-muted" style="padding:50px 0">没选择企业</div>
            <div v-else class="text-center text-muted" style="padding:50px 0">暂无附件（后续对接）</div>
          </div>

          <!-- 历史监测 -->
          <div v-show="tab === 'history'">
            <div v-if="!current" class="text-center text-muted" style="padding:50px 0">没选择企业</div>
            <div v-else class="history-panel">
              <div class="history-block-title">各年点位方案</div>
              <el-table v-if="siteYearSummary.length" :data="siteYearSummary" size="mini" max-height="160" empty-text="暂无点位">
                <el-table-column label="方案日期" width="100">
                  <template slot-scope="{ row }">{{ formatSchemeYearDisplay(row.scheme_year) }}</template>
                </el-table-column>
                <el-table-column prop="site_cnt" label="点位数" width="80" align="center" />
                <el-table-column label="操作" min-width="180">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="openYearSites(row.scheme_year)">查看点位</el-button>
                    <el-button
                      v-if="yearKey(row.scheme_year) > 0 && yearKey(row.scheme_year) !== viewSchemeYear"
                      type="text"
                      size="mini"
                      :loading="copySaving"
                      @click="copySitesFromYear(row.scheme_year)"
                    >复制到 {{ viewSchemeYear }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-tab history-empty">暂无分年点位方案</div>
              <div class="history-block-title">往年周期项目</div>
              <el-table v-if="historyProjects.length" :data="historyProjects" size="mini" max-height="160" empty-text="暂无项目">
                <el-table-column prop="routine_year" label="年度" width="72" align="center" />
                <el-table-column prop="xmbh" label="项目编号" width="120" show-overflow-tooltip />
                <el-table-column prop="xmmc" label="任务名称" min-width="140" show-overflow-tooltip />
                <el-table-column label="状态" width="90" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.entrust_status || row.xmzt || '—' }}</template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-tab history-empty">暂无往年周期项目</div>
            </div>
          </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="padding-top:5px;padding-bottom:5px;">
            <button type="button" class="btn btn-primary" :disabled="!current || confirmSaving" @click="confirm">
              <i class="fa fa-check"></i>确定
            </button>
            <button type="button" class="btn btn-default" @click="visible=false">
              <i class="fa fa-close"></i>取消
            </button>
          </div>
        </div>
      </div>
    </div>
<!-- 嵌套：企业信息 — 对齐 Ivan showWin width:800 -->
    <div v-show="showAdd" class="ivan-sub-win">
      <div class="modal-backdrop fade in ivan-sub-backdrop" @click="showAdd=false"></div>
      <div class="modal fade in ivan-sub-modal" style="display:block" tabindex="-1">
        <div class="modal-dialog" style="width:800px; margin:20px auto;">
          <div class="modal-content">
            <div class="modal-header" style="padding:8px 15px;">
              <button type="button" class="close" @click="showAdd=false"><span>&times;</span></button>
              <h4 class="modal-title">企业信息</h4>
            </div>
            <div class="modal-body" :style="subWinBodyStyle">
              <el-form :model="addForm" label-width="90px" size="small">
                <el-form-item label="企业编号">
                  <el-input v-model="addForm.ent_code" :placeholder="nextEntCodeHint" />
                </el-form-item>
                <el-form-item label="企业名称" required><el-input v-model="addForm.ent_name" /></el-form-item>
                <el-form-item label="行业"><el-input v-model="addForm.industry" /></el-form-item>
                <el-form-item label="行政区域">
                  <el-row :gutter="8">
                    <el-col :span="8">
                      <el-select v-model="addForm.province" placeholder="省" filterable clearable style="width:100%" @change="onProvinceChange">
                        <el-option v-for="p in provinceOptions" :key="p" :label="p" :value="p" />
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-select v-model="addForm.city" placeholder="市" filterable clearable style="width:100%" :disabled="!addForm.province" @change="onCityChange">
                        <el-option v-for="c in cityOptions" :key="c" :label="c" :value="c" />
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-select v-model="addForm.district" placeholder="区县" filterable clearable style="width:100%" :disabled="!addForm.city">
                        <el-option v-for="d in districtOptions" :key="d" :label="d" :value="d" />
                      </el-select>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="邮编"><el-input v-model="addForm.zip_code" /></el-form-item>
                <el-form-item label="详细地址"><el-input v-model="addForm.address" /></el-form-item>
                <el-row :gutter="12">
                  <el-col :span="12"><el-form-item label="经度"><el-input v-model="addForm.longitude" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="纬度"><el-input v-model="addForm.latitude" /></el-form-item></el-col>
                </el-row>
                <el-row :gutter="12">
                  <el-col :span="12"><el-form-item label="联系人"><el-input v-model="addForm.linkman" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="电话"><el-input v-model="addForm.phone" /></el-form-item></el-col>
                </el-row>
                <el-row :gutter="12">
                  <el-col :span="12"><el-form-item label="传真"><el-input v-model="addForm.fax" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="邮箱"><el-input v-model="addForm.email" /></el-form-item></el-col>
                </el-row>
                <el-form-item label="备注"><el-input v-model="addForm.remark" type="textarea" :rows="2" /></el-form-item>
              </el-form>
            </div>
            <div class="modal-footer" style="padding-top:5px;padding-bottom:5px;">
              <button type="button" class="btn btn-primary" :disabled="addSaving" @click="saveNew">
                <i class="fa fa-save"></i>确定
              </button>
              <button type="button" class="btn btn-default" @click="showAdd=false">
                <i class="fa fa-close"></i>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 点位信息 — 同 Ivan 二级窗 -->
    <div v-show="showSite" class="ivan-sub-win">
      <div class="modal-backdrop fade in ivan-sub-backdrop" @click="showSite=false"></div>
      <div class="modal fade in ivan-sub-modal" style="display:block" tabindex="-1">
        <div class="modal-dialog" style="width:640px; margin:20px auto;">
          <div class="modal-content">
            <div class="modal-header" style="padding:8px 15px;">
              <button type="button" class="close" @click="showSite=false"><span>&times;</span></button>
              <h4 class="modal-title">点位信息</h4>
            </div>
            <div class="modal-body" :style="subWinBodyStyle">
<el-form :model="siteForm" label-width="112px" size="small">
        <el-form-item label="点位编号及名称" required>
          <el-input v-model="siteForm.site_name" placeholder="如：废气：DA003工艺废气1#" />
        </el-form-item>
        <el-form-item label="基本类型">
          <el-select v-model="siteForm.basic_type" placeholder="选择基本类型" clearable filterable style="width:100%" @change="onSiteBasicChange">
            <el-option v-for="b in basicTypes" :key="b.label" :label="b.label" :value="b.label" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="siteSubTypes.length" label="详细类型">
          <el-select v-model="siteForm.sub_type" placeholder="选择详细类型" clearable filterable style="width:100%" @change="onSiteSubChange">
            <el-option v-for="s in siteSubTypes" :key="s.label" :label="s.label" :value="s.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="监测项目">
          <el-input
            v-model="siteForm.item_names"
            type="textarea"
            :rows="siteItemTextareaRows"
            placeholder="手动填写，或点「选择检测因子」从 CMA 能力表勾选"
          />
          <div class="site-item-actions">
            <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="pickCma">
              选择检测因子
            </el-button>
            <el-button v-if="siteItemCount" type="text" size="mini" @click="dedupeSiteItems">去除重复</el-button>
            <el-button v-if="siteItemCount" type="text" size="mini" @click="clearSiteItems">清空</el-button>
            <span v-if="siteItemCount" class="site-item-count">已选 {{ siteItemCount }} 项</span>
          </div>
        </el-form-item>
        <el-form-item label="监测频次">
          <el-select
            v-model="siteForm.freq_label"
            placeholder="请选择：季测、月测等"
            style="width:100%"
            :disabled="!Object.keys(effectiveFreqPresets).length"
            @change="applySiteFreqPreset"
          >
            <el-option
              v-for="(p, k) in effectiveFreqPresets"
              :key="k"
              :label="routinePresetOptionLabel(k, p)"
              :value="k"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方法依据">
          <el-input v-model="siteForm.method_accord" placeholder="可选" />
        </el-form-item>
        <el-form-item label="方案日期">
          <el-date-picker
            v-model="siteFormSchemeDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="small"
            :clearable="false"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="siteForm.remark" placeholder="可选" />
        </el-form-item>
      </el-form>
            </div>
            <div class="modal-footer" style="padding-top:5px;padding-bottom:5px;">
              <button type="button" class="btn btn-primary" :disabled="siteSaving" @click="saveSite">
                <i class="fa fa-save"></i>确定
              </button>
              <button type="button" class="btn btn-default" @click="showSite=false">
                <i class="fa fa-close"></i>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="CMA 检测因子" :visible.sync="showCma" width="760px" top="5vh" append-to-body :z-index="3100" @open="onCmaOpen">
      <el-row :gutter="8" class="cma-filter-row">
        <el-col :span="11">
          <el-select
            v-model="cmaMajor"
            filterable
            clearable
            placeholder="能力大类（可按基本类型自动匹配）"
            size="small"
            style="width:100%"
            @change="loadCma(1)"
          >
            <el-option v-for="m in cmaMajors" :key="m" :label="m" :value="m" />
          </el-select>
        </el-col>
        <el-col :span="13">
          <el-input
            v-model="cmaKw"
            placeholder="搜索检测因子 / 方法"
            clearable
            size="small"
            @keyup.enter.native="loadCma(1)"
            @clear="loadCma(1)"
          >
            <el-button slot="append" @click="loadCma(1)">搜索</el-button>
          </el-input>
        </el-col>
      </el-row>
      <div class="cma-toolbar">
        <span class="cma-stat">共 {{ cmaTotal }} 条 · 已勾选 {{ cmaSelected.length }} 条</span>
        <el-button type="text" size="mini" @click="selectAllCmaPage">全选本页</el-button>
      </div>
      <el-table
        ref="cmaTable"
        v-loading="cmaLoading"
        :data="cmaRows"
        size="mini"
        max-height="320"
        row-key="id"
        @selection-change="onCmaSel"
      >
        <el-table-column type="selection" width="45" reserve-selection />
        <el-table-column prop="param_name" label="检测因子" min-width="120" show-overflow-tooltip />
        <el-table-column prop="std_name" label="方法" min-width="180" show-overflow-tooltip />
        <el-table-column prop="category_major" label="大类" min-width="140" show-overflow-tooltip />
      </el-table>
      <el-pagination
        small
        layout="total, prev, pager, next"
        :total="cmaTotal"
        :page-size="cmaPageSize"
        :current-page.sync="cmaPage"
        class="cma-pager"
        @current-change="loadCma"
      />
            <div slot="footer">
        <el-button @click="showCma=false">取消</el-button>
        <el-button type="primary" @click="applyCma">添加所选因子</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/utils/api'
import { listProvinces, listCities, listDistricts } from '@/utils/chinaRegion'
import { resolveRoutinePresetKey, routinePresetOptionLabel } from '@/utils/routineFreq'
import { normalizeLegacyBasicType, ensureDefaultSubType } from '@/utils/routineTypeInfer'
import { looksLikeItemNames, siteToMonitorItem } from '@/utils/siteMonitorMap'
import {
  todayDateStr,
  deriveSchemeDate,
  yearFromDateStr,
  yearOnlyToDisplayDate,
  normalizeSchemeDateStr
} from '@/utils/schemeDate'
import {
  cmaMajorForBasicType,
  mergeCmaRows,
  splitItemNames,
  splitItemIds,
  dedupeItemFields
} from '@/utils/cmaItemPick'
function emptyAddForm() {
  return {
    id: 0,
    ent_name: '',
    ent_code: '',
    address: '',
    industry: '',
    province: '',
    city: '',
    district: '',
    zip_code: '',
    longitude: '',
    latitude: '',
    linkman: '',
    phone: '',
    fax: '',
    email: '',
    remark: ''
  }
}

function emptySiteForm() {
  return {
    id: 0,
    region_name: '',
    region_code: '',
    site_name: '',
    site_code: '',
    basic_type: '',
    sub_type: '',
    type_code: '',
    item_ids: '',
    item_names: '',
    method_accord: '',
    remark: '',
    freq_unit: 'period',
    freq_count: 1,
    periods_count: 4,
    freq_label: '',
    schedule_json: '',
    scheme_year: new Date().getFullYear(),
    scheme_date: todayDateStr()
  }
}

export default {
  props: {
    value: { type: Boolean, default: false },
    siteImportEnabled: { type: Boolean, default: true },
    schemeYear: { type: [Number, String], default: () => new Date().getFullYear() },
    schemeDate: { type: String, default: '' },
    typeConfig: { type: Object, default: () => ({}) },
    typeInferConfig: { type: Object, default: () => ({}) },
    freqPresets: { type: Object, default: () => ({}) },
    isRoutine: { type: Boolean, default: true }
  },
  data() {
    return {
      keyword: '',
      sortRule: (typeof localStorage !== 'undefined' && localStorage.getItem('enterprise_sortRuleValue')) || 'ent_name',
      list: [],
      loading: false,
      current: null,
      tab: 'basic',
      sites: [],
      viewSchemeYear: new Date().getFullYear(),
      viewSchemeDate: todayDateStr(),
      siteYearSummary: [],
      historyProjects: [],
      copySaving: false,
      showAdd: false,
      addSaving: false,
      entDeleting: false,
      nextEntCodePreview: '',
      addForm: emptyAddForm(),
      editForm: emptyAddForm(),
      editSaving: false,
      basicEditing: false,
      confirmSaving: false,
      showSite: false,
      siteSaving: false,
      siteForm: emptySiteForm(),
      showCma: false,
      cmaKw: '',
      cmaMajor: '',
      cmaMajors: [],
      cmaPage: 1,
      cmaPageSize: 100,
      cmaTotal: 0,
      cmaLoading: false,
      cmaRows: [],
      cmaSelected: [],
      typeConfigLocal: {},
      freqPresetsLocal: {},
      typeInferConfigLocal: {},
      selectedSites: [],
      /** 用户主动取消勾选后为 false，confirm 不再按默认全选兜底导入 */
      allowImportFallback: true
    }
  },
  watch: {
    value(v) {
      if (v) {
        this.$nextTick(() => {
          this.onOpen()
          try { document.body.classList.add('modal-open') } catch (e) { /* ignore */ }
        })
      } else {
        this.showAdd = false
        this.showSite = false
        this.showCma = false
        try { document.body.classList.remove('modal-open') } catch (e) { /* ignore */ }
      }
    },
    schemeYear: {
      immediate: true,
      handler(v) {
        const y = this.normalizeYear(v)
        if (y !== this.viewSchemeYear) {
          this.viewSchemeYear = y
          this.viewSchemeDate = deriveSchemeDate(y, this.viewSchemeDate)
          if (this.current && this.current.id) this.reloadSites()
        }
      }
    },
    schemeDate: {
      immediate: true,
      handler(v) {
        const d = normalizeSchemeDateStr(v, this.viewSchemeDate)
        if (d && d !== this.viewSchemeDate) {
          this.viewSchemeDate = d
          this.viewSchemeYear = yearFromDateStr(d)
        }
      }
    },
    tab(v) {
      if ((v === 'history' || v === 'sites') && this.current && this.current.id) this.loadYearSummary()
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    /** 对齐 Ivan showWin(full) */
    modalDialogStyle() {
      const margin = 40
      const w = Math.max(320, (typeof window !== 'undefined' ? window.innerWidth : 1200) - margin)
      return { width: w + 'px', margin: '20px auto' }
    },
    modalBodyStyle() {
      const margin = 40
      const header = 46
      const footer = 50
      const h = Math.max(300, (typeof window !== 'undefined' ? window.innerHeight : 800) - margin - header - footer)
      return { height: h + 'px', maxHeight: h + 'px', overflow: 'hidden', paddingTop: '10px', paddingBottom: '10px' }
    },
    /** 对齐 Ivan showWin：body 仅 max-height + 滚动，不强制撑满 */
    subWinBodyStyle() {
      const h = typeof window !== 'undefined' ? window.innerHeight : 800
      const max = Math.max(240, h - 40 - 50 - 55)
      return {
        maxHeight: max + 'px',
        overflowY: 'auto',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    },
    /** 对齐 Ivan：按企业名称 / 企业编号排序 */
    sortedList() {
      const key = this.sortRule === 'ent_code' ? 'ent_code' : 'ent_name'
      return [...(this.list || [])].sort((a, b) => {
        const av = String((a && a[key]) || '')
        const bv = String((b && b[key]) || '')
        return av.localeCompare(bv, 'zh-CN')
      })
    },
    siteFormSchemeDate: {
      get() {
        return normalizeSchemeDateStr(
          this.siteForm.scheme_date,
          deriveSchemeDate(this.siteForm.scheme_year || this.viewSchemeYear, this.viewSchemeDate)
        )
      },
      set(v) {
        const d = normalizeSchemeDateStr(v, todayDateStr())
        this.siteForm.scheme_date = d
        this.siteForm.scheme_year = yearFromDateStr(d)
      }
    },
    copySourceYears() {
      const cur = this.viewSchemeYear
      const years = (this.siteYearSummary || [])
        .map(r => this.yearKey(r.scheme_year))
        .filter(y => y !== cur)
      return [...new Set(years)].sort((a, b) => b - a)
    },
    /** 点位项目工具栏：方案日期下拉（主表单日期 + 该企业历年方案） */
    schemeDateOptions() {
      const ref = normalizeSchemeDateStr(this.schemeDate, this.viewSchemeDate || todayDateStr())
      const years = new Set()
      const addYear = (y) => {
        const n = parseInt(y, 10)
        if (n > 0) years.add(n)
      }
      addYear(yearFromDateStr(ref))
      addYear(this.viewSchemeYear)
      for (const row of (this.siteYearSummary || [])) {
        addYear(this.yearKey(row.scheme_year))
      }
      for (const p of (this.historyProjects || [])) {
        addYear(p.routine_year)
      }
      const list = [...years].sort((a, b) => b - a).map(y => {
        const value = deriveSchemeDate(y, ref)
        return { value, label: value, year: y }
      })
      const cur = normalizeSchemeDateStr(this.viewSchemeDate, ref)
      if (cur && !list.some(x => x.value === cur)) {
        list.unshift({ value: cur, label: cur, year: yearFromDateStr(cur) })
      }
      if (!list.length) {
        const today = todayDateStr()
        list.push({ value: today, label: today, year: yearFromDateStr(today) })
      }
      return list
    },
    basicTypes() {
      const cfg = this.typeConfig.basicTypes ? this.typeConfig : this.typeConfigLocal
      return (cfg && cfg.basicTypes) || []
    },
    effectiveFreqPresets() {
      if (this.freqPresets && Object.keys(this.freqPresets).length) return this.freqPresets
      return this.freqPresetsLocal
    },
    effectiveTypeInfer() {
      if (this.typeInferConfig && Object.keys(this.typeInferConfig).length) return this.typeInferConfig
      return this.typeInferConfigLocal
    },
    effectiveTypeConfig() {
      if (this.typeConfig && (this.typeConfig.basicTypes || this.typeConfig.monitorTypes)) return this.typeConfig
      return this.typeConfigLocal
    },
    siteSubTypes() {
      const b = this.basicTypes.find(x => x.label === this.siteForm.basic_type)
      return b ? (b.subTypes || []) : []
    },
    siteItemCount() {
      return splitItemNames(this.siteForm.item_names).length
    },
    siteItemTextareaRows() {
      const n = this.siteItemCount
      if (!n) return 5
      return Math.min(14, Math.max(6, Math.ceil(n / 12) + 4))
    },
    provinceOptions() {
      return listProvinces()
    },
    cityOptions() {
      return listCities(this.addForm.province)
    },
    districtOptions() {
      return listDistricts(this.addForm.province, this.addForm.city)
    },
    nextEntCodeHint() {
      return this.nextEntCodePreview
        ? `留空则自动生成 ${this.nextEntCodePreview}`
        : '留空自动生成 ENT2026-0001'
    }
  },
  methods: {
    contactText(row) {
      if (!row) return ''
      const parts = [row.linkman, row.phone].filter(Boolean)
      return parts.join(' · ')
    },
    regionText(row) {
      if (!row) return '—'
      const parts = [row.province, row.city, row.district].filter(Boolean)
      return parts.length ? parts.join(' / ') : '—'
    },
    entRowClass({ row }) {
      return row && this.current && row.id === this.current.id ? 'ent-pick-row-active' : ''
    },
    syncEntTableCurrent() {
      this.$nextTick(() => {
        const tbl = this.$refs.entTable
        if (!tbl) return
        tbl.setCurrentRow(this.current || null)
      })
    },
    formatSchemeYearDisplay(y) {
      return yearOnlyToDisplayDate(y)
    },
    siteFreqLabel(row) {
      if (!row) return '—'
      const presets = this.effectiveFreqPresets
      const raw = String(row.freq_label || '').trim()
      if (raw && raw !== '__custom__' && raw !== '自定义') {
        const key = resolveRoutinePresetKey(raw, presets)
        if (key) return key
        return raw
      }
      const fc = parseInt(row.freq_count, 10)
      const pc = parseInt(row.periods_count, 10)
      // 旧数据常无频次：默认显示为 1次/期·共1期，易误导；无有效配置时显示「未设」
      const hasFreq = (fc > 0 && pc > 0) || raw
      if (!hasFreq && !raw) return '未设'
      const freqCount = fc > 0 ? fc : 1
      const periods = pc > 0 ? pc : 1
      if (row.freq_unit === 'period' || this.isRoutine) {
        return `${freqCount}次/期，共${periods}期`
      }
      return `${parseInt(row.freq_per_day, 10) || freqCount}次/天`
    },
    normalizeYear(v) {
      const y = parseInt(v, 10)
      return y > 0 ? y : new Date().getFullYear()
    },
    yearLabel(y) {
      const n = parseInt(y, 10)
      if (!n || n <= 0) return '未标年'
      return String(n)
    },
    /** 未标年用 0 参与复制；展示用 yearLabel */
    yearKey(y) {
      const n = parseInt(y, 10)
      return n > 0 ? n : 0
    },
    onOpen() {
      this.current = null
      this.editForm = emptyAddForm()
      this.basicEditing = false
      this.tab = 'basic'
      this.sites = []
      this.selectedSites = []
      this.siteYearSummary = []
      this.historyProjects = []
      this.loadMeta()
      this.viewSchemeYear = this.normalizeYear(this.schemeYear)
      this.viewSchemeDate = normalizeSchemeDateStr(this.schemeDate, deriveSchemeDate(this.schemeYear, todayDateStr()))
      this.allowImportFallback = true
      try {
        const saved = localStorage.getItem('enterprise_sortRuleValue')
        if (saved === 'ent_name' || saved === 'ent_code') this.sortRule = saved
      } catch (e) { /* ignore */ }
      this.search()
    },
    onSortChange() {
      try { localStorage.setItem('enterprise_sortRuleValue', this.sortRule) } catch (e) { /* ignore */ }
    },
    async startEditFromList(row) {
      if (!row) return
      await this.onPick(row)
      this.tab = 'basic'
      this.openEditEnt(row)
    },
    async deleteEntFromList(row) {
      if (!row) return
      await this.onPick(row)
      await this.deleteEnt()
    },
    openAddEnt() {
      this.addForm = emptyAddForm()
      this.showAdd = true
      this.loadMeta()
      this.loadNextEntCode()
    },
    openEditEnt(row) {
      const r = row || this.current
      if (!r || !r.id) {
        this.$message.warning('请先选择企业')
        return
      }
      this.addForm = {
        ...emptyAddForm(),
        id: r.id || 0,
        ent_name: r.ent_name || '',
        ent_code: r.ent_code || '',
        address: r.address || '',
        industry: r.industry || '',
        province: r.province || '',
        city: r.city || '',
        district: r.district || '',
        zip_code: r.zip_code || '',
        longitude: r.longitude || '',
        latitude: r.latitude || '',
        linkman: r.linkman || '',
        phone: r.phone || '',
        fax: r.fax || '',
        email: r.email || '',
        remark: r.remark || ''
      }
      this.showAdd = true
      this.loadMeta()
    },
    async loadNextEntCode() {
      try {
        const res = await api.get('yn_ent_next_code', { year: new Date().getFullYear() })
        this.nextEntCodePreview = (res.data && res.data.ent_code) || ''
      } catch (e) {
        this.nextEntCodePreview = ''
      }
    },
    async deleteEnt() {
      if (!this.current || !this.current.id) return
      try {
        await this.$confirm(
          `确定删除企业「${this.current.ent_name}」及其全部点位？已有委托项目的企业不能删除。`,
          '删除企业',
          { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' }
        )
      } catch (e) {
        return
      }
      this.entDeleting = true
      try {
        const res = await api.postJson('yn_ent_delete', { id: this.current.id })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        if (!res.data || !res.data.ok) {
          this.$message.error('删除失败，请稍后重试')
          return
        }
        this.$message.success(`已删除企业「${(res.data && res.data.ent_name) || ''}」`)
        this.current = null
        this.sites = []
        this.selectedSites = []
        await this.search()
        this.syncEntTableCurrent()
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.error) || '删除失败，请检查网络或联系管理员'
        this.$message.error(msg)
      } finally {
        this.entDeleting = false
      }
    },
    async deleteSite(row) {
      if (!row || !row.id) return
      const name = (row.site_name || '').trim() || '该点位'
      try {
        await this.$confirm(`确定删除点位「${name}」？`, '删除点位', {
          type: 'warning',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }
      try {
        const res = await api.postJson('yn_ent_site_delete', { id: row.id })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        this.$message.success('点位已删除')
        this.selectedSites = this.selectedSites.filter(s => s.id !== row.id)
        await Promise.all([this.reloadSites(), this.loadYearSummary()])
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async loadMeta() {
      try {
        const [typesRes, metaRes] = await Promise.all([
          api.get('yn_entrust_types'),
          api.get('yn_routine_meta')
        ])
        this.typeConfigLocal = typesRes.data || {}
        const meta = metaRes.data || {}
        const presets = meta.freq_presets || {}
        this.freqPresetsLocal = presets.presets || presets || {}
        this.typeInferConfigLocal = meta.type_infer || {}
      } catch (e) {
        this.typeConfigLocal = {}
        this.freqPresetsLocal = {}
        this.typeInferConfigLocal = {}
      }
    },
    async onViewDateChange(v) {
      const d = normalizeSchemeDateStr(v, this.viewSchemeDate)
      this.viewSchemeDate = d
      this.viewSchemeYear = yearFromDateStr(d)
      this.allowImportFallback = true
      await this.reloadSites()
    },
    async loadYearSummary() {
      if (!this.current || !this.current.id) {
        this.siteYearSummary = []
        this.historyProjects = []
        return
      }
      try {
        const res = await api.get('yn_ent_site_year_summary', { ent_id: this.current.id })
        const data = res.data || {}
        this.siteYearSummary = data.years || []
        this.historyProjects = data.projects || []
      } catch (e) {
        this.siteYearSummary = []
        this.historyProjects = []
      }
    },
    async openYearSites(year) {
      const y = this.normalizeYear(year)
      this.viewSchemeYear = y
      this.viewSchemeDate = deriveSchemeDate(y, this.viewSchemeDate)
      this.tab = 'sites'
      this.allowImportFallback = true
      await this.reloadSites()
    },
    async copySitesFromYear(fromYear) {
      if (!this.current || !this.current.id) return
      const from = this.yearKey(fromYear)
      const to = this.viewSchemeYear
      if (from === to) {
        this.$message.warning('源年与当前方案年相同')
        return
      }
      if (to <= 0) {
        this.$message.warning('请先选择有效的目标方案年')
        return
      }
      this.copySaving = true
      try {
        const res = await api.postJson('yn_ent_site_copy_year', {
          ent_id: this.current.id,
          from_year: from,
          to_year: to
        })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        const copied = (res.data && res.data.copied) || 0
        const skipped = (res.data && res.data.skipped) || 0
        const fromLabel = from > 0 ? `${from} 年` : '未标年'
        this.$message.success(`已从 ${fromLabel} 复制 ${copied} 条到 ${to} 年` + (skipped ? `，跳过已有 ${skipped} 条` : ''))
        await this.loadYearSummary()
        await this.reloadSites()
        this.tab = 'sites'
      } finally {
        this.copySaving = false
      }
    },
    async reloadSites() {
      if (!this.current || !this.current.id) {
        this.sites = []
        this.selectedSites = []
        return
      }
      const res = await api.get('yn_ent_site_list', {
        ent_id: this.current.id,
        scheme_year: this.viewSchemeYear
      })
      this.sites = res.data || []
      if (this.siteImportEnabled && this.sites.length) {
        await this.$nextTick()
        await this.selectAllSitesAfterReload()
      } else {
        this.selectedSites = []
      }
    },
    async search() {
      this.loading = true
      try {
        const res = await api.get('yn_ent_list', { key: this.keyword })
        this.list = res.data || []
        this.syncEntTableCurrent()
      } finally { this.loading = false }
    },
    onRowClick(row) {
      if (!row) return
      this.onPick(row)
      this.syncEntTableCurrent()
    },
    switchTab(name) {
      this.tab = name
      if (typeof document !== 'undefined' && document.activeElement) {
        document.activeElement.blur()
      }
    },
    onPick(row) {
      // Element UI 切换行时会先 emit null，忽略以免异步 reload 后被清空
      if (!row) return
      const entId = row.id
      this.current = row
      this.basicEditing = false
      this.fillEditForm(row)
      this.allowImportFallback = true
      this.viewSchemeYear = this.normalizeYear(this.schemeYear)
      this.viewSchemeDate = normalizeSchemeDateStr(this.schemeDate, deriveSchemeDate(this.schemeYear, todayDateStr()))
      // 对齐 Ivan：选中后停留在当前 Tab（默认基本信息），不强制跳点位
      return Promise.all([this.reloadSites(), this.loadYearSummary()]).then(() => {
        if (!this.current || this.current.id !== entId) return
        this.syncEntTableCurrent()
      })
    },
    fillEditForm(row) {
      const r = row || {}
      this.editForm = {
        ...emptyAddForm(),
        id: r.id || 0,
        ent_name: r.ent_name || '',
        ent_code: r.ent_code || '',
        address: r.address || '',
        industry: r.industry || '',
        province: r.province || '',
        city: r.city || '',
        district: r.district || '',
        zip_code: r.zip_code || '',
        longitude: r.longitude || '',
        latitude: r.latitude || '',
        linkman: r.linkman || '',
        phone: r.phone || '',
        fax: r.fax || '',
        email: r.email || '',
        remark: r.remark || ''
      }
    },
    onSiteSelectionChange(rows) {
      const list = rows || []
      this.selectedSites = list
      if (list.length < this.sites.length) {
        this.allowImportFallback = false
      }
    },
    async selectAllSites() {
      this.allowImportFallback = true
      await this.$nextTick()
      const tbl = this.$refs.siteTable
      if (!tbl) return
      tbl.clearSelection()
      this.sites.forEach(row => tbl.toggleRowSelection(row, true))
      await this.$nextTick()
      if (!this.selectedSites.length && this.sites.length) {
        this.selectedSites = [...this.sites]
      }
    },
    clearSiteSelection() {
      this.allowImportFallback = false
      const tbl = this.$refs.siteTable
      if (!tbl) return
      tbl.clearSelection()
      this.selectedSites = []
    },
    async selectAllSitesAfterReload() {
      await this.$nextTick()
      const tbl = this.$refs.siteTable
      if (!tbl || !this.sites.length) {
        this.selectedSites = []
        return
      }
      tbl.clearSelection()
      this.sites.forEach(row => tbl.toggleRowSelection(row, true))
      await this.$nextTick()
      if (!this.selectedSites.length) {
        this.selectedSites = [...this.sites]
      }
    },
    onProvinceChange() {
      this.addForm.city = ''
      this.addForm.district = ''
    },
    onCityChange() {
      this.addForm.district = ''
    },
    openSiteAdd() {
      if (!this.current || !this.current.id) {
        this.$message.warning('请先选择或新增企业')
        return
      }
      this.siteForm = {
        ...emptySiteForm(),
        scheme_year: this.viewSchemeYear,
        scheme_date: this.viewSchemeDate
      }
      this.showSite = true
      this.$nextTick(() => this.onSiteDialogOpen())
    },
    openSiteEdit(row) {
      if (!row) return
      this.siteForm = {
        ...emptySiteForm(),
        ...row,
        id: row.id || 0,
        freq_count: parseInt(row.freq_count, 10) || 1,
        periods_count: parseInt(row.periods_count, 10) || 1,
        freq_unit: row.freq_unit || 'period',
        schedule_json: row.schedule_json || '',
        scheme_year: this.normalizeYear(row.scheme_year || this.viewSchemeYear),
        scheme_date: deriveSchemeDate(row.scheme_year || this.viewSchemeYear, this.viewSchemeDate),
        freq_label: resolveRoutinePresetKey(row.freq_label, this.effectiveFreqPresets) || row.freq_label || ''
      }
      if (this.siteForm.freq_label) this.applySiteFreqPreset(this.siteForm.freq_label)
      const norm = normalizeLegacyBasicType(this.siteForm.basic_type, this.siteForm.sub_type)
      this.siteForm.basic_type = norm.basic_type
      this.siteForm.sub_type = norm.sub_type
      ensureDefaultSubType(this.siteForm, this.effectiveTypeConfig)
      const deduped = dedupeItemFields(
        this.siteForm.item_ids,
        this.siteForm.item_names,
        this.siteForm.method_accord
      )
      this.siteForm.item_ids = deduped.item_ids
      this.siteForm.item_names = deduped.item_names
      this.siteForm.method_accord = deduped.method_accord
      this.showSite = true
      this.$nextTick(() => this.onSiteDialogOpen())
    },
    async onSiteDialogOpen() {
      if (!this.siteForm.basic_type && this.basicTypes.length === 1) {
        this.siteForm.basic_type = this.basicTypes[0].label
      }
    },
    onSiteBasicChange() {
      this.siteForm.sub_type = ''
      this.siteForm.type_code = ''
      ensureDefaultSubType(this.siteForm, this.effectiveTypeConfig)
      const s = this.siteSubTypes.find(x => x.label === this.siteForm.sub_type)
      if (s) this.siteForm.type_code = s.code || ''
    },
    onSiteSubChange() {
      const s = this.siteSubTypes.find(x => x.label === this.siteForm.sub_type)
      this.siteForm.type_code = s ? (s.code || '') : ''
    },
    routinePresetOptionLabel,
    applySiteFreqPreset(label) {
      const presets = this.effectiveFreqPresets
      const key = resolveRoutinePresetKey(label, presets)
      if (key && key !== label) this.siteForm.freq_label = key
      if (!key || !presets[key]) return
      const p = presets[key]
      if (p.freq_count) this.siteForm.freq_count = p.freq_count
      if (p.periods_count) this.siteForm.periods_count = p.periods_count
      if (p.schedule) {
        this.siteForm.schedule_json = typeof p.schedule === 'string' ? p.schedule : JSON.stringify(p.schedule)
      }
    },
    pickCma() {
      this.showCma = true
    },
    async onCmaOpen() {
      this.cmaSelected = []
      this.cmaPage = 1
      if (!this.cmaMajors.length) {
        try {
          const res = await api.get('yn_cma_scope_meta', {})
          this.cmaMajors = (res.data && res.data.majors) || []
        } catch (e) {
          this.cmaMajors = []
        }
      }
      this.cmaMajor = cmaMajorForBasicType(this.siteForm.basic_type)
      await this.loadCma(1)
      this.$nextTick(() => {
        const tbl = this.$refs.cmaTable
        if (tbl) tbl.clearSelection()
      })
    },
    async loadCma(page) {
      if (page) this.cmaPage = page
      this.cmaLoading = true
      try {
        const res = await api.get('yn_cma_scope_list', {
          page: this.cmaPage,
          page_size: this.cmaPageSize,
          keyword: this.cmaKw,
          major: this.cmaMajor
        })
        const d = res.data || {}
        this.cmaRows = d.items || []
        this.cmaTotal = d.total || 0
      } finally {
        this.cmaLoading = false
      }
    },
    onCmaSel(rows) { this.cmaSelected = rows || [] },
    selectAllCmaPage() {
      const tbl = this.$refs.cmaTable
      if (!tbl) return
      this.cmaRows.forEach(row => tbl.toggleRowSelection(row, true))
    },
    clearSiteItems() {
      this.siteForm.item_ids = ''
      this.siteForm.item_names = ''
      this.siteForm.method_accord = ''
    },
    dedupeSiteItems() {
      const before = this.siteItemCount
      const d = dedupeItemFields(
        this.siteForm.item_ids,
        this.siteForm.item_names,
        this.siteForm.method_accord
      )
      this.siteForm.item_ids = d.item_ids
      this.siteForm.item_names = d.item_names
      this.siteForm.method_accord = d.method_accord
      const after = splitItemNames(d.item_names).length
      if (after < before) {
        this.$message.success(`已去除 ${before - after} 个重复因子`)
      } else {
        this.$message.info('没有重复项')
      }
    },
    applyCmaRows(rows, closeDialog) {
      const merged = mergeCmaRows(
        this.siteForm.item_ids,
        this.siteForm.item_names,
        this.siteForm.method_accord,
        rows
      )
      this.siteForm.item_ids = merged.item_ids
      this.siteForm.item_names = merged.item_names
      this.siteForm.method_accord = merged.method_accord
      if (closeDialog) this.showCma = false
    },
    applyCma() {
      if (!this.cmaSelected.length) {
        this.$message.warning('请先勾选检测因子')
        return
      }
      const before = this.siteItemCount
      this.applyCmaRows(this.cmaSelected, true)
      const added = this.siteItemCount - before
      this.$message.success(added > 0 ? `已添加 ${added} 个检测因子` : '所选因子已在列表中')
    },
    async saveSite() {
      if (!this.siteForm.site_name || !this.siteForm.site_name.trim()) {
        this.$message.warning('请填写点位/断面名称')
        return
      }
      if (looksLikeItemNames(this.siteForm.site_name) && !String(this.siteForm.item_names || '').trim()) {
        this.siteForm.item_names = this.siteForm.site_name.trim()
        this.siteForm.site_name = this.siteForm.region_name || ''
        if (!this.siteForm.site_name.trim()) {
          this.$message.warning('原「点位名称」实为监测项目，已拆到监测项目列，请补填点位/断面名称')
        }
      }
      if (!this.current || !this.current.id) {
        this.$message.warning('请先选择或新增企业')
        return
      }
      const itemCnt = splitItemNames(this.siteForm.item_names).length
      if (itemCnt > 3000) {
        this.$message.warning(`检测因子过多（${itemCnt} 项），请删减后保存`)
        return
      }
      this.siteSaving = true
      try {
        if (this.siteForm.freq_label) {
          this.applySiteFreqPreset(this.siteForm.freq_label)
        }
        ensureDefaultSubType(this.siteForm, this.effectiveTypeConfig)
        const payload = {
          ...this.siteForm,
          ent_id: this.current.id,
          site_name: this.siteForm.site_name.trim(),
          scheme_year: yearFromDateStr(this.siteForm.scheme_date || this.viewSchemeDate)
        }
        const res = await api.postJson('yn_ent_site_save', payload)
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        this.showSite = false
        this.viewSchemeYear = payload.scheme_year
        this.viewSchemeDate = normalizeSchemeDateStr(this.siteForm.scheme_date, this.viewSchemeDate)
        await Promise.all([this.reloadSites(), this.loadYearSummary()])
        this.$message.success(this.siteForm.id ? '已更新点位' : '已新增点位')
      } finally {
        this.siteSaving = false
      }
    },
    async saveNew() {
      if (!this.addForm.ent_name || !this.addForm.ent_name.trim()) {
        this.$message.warning('请填写企业名称')
        return
      }
      this.addSaving = true
      const isEdit = !!(this.addForm.id)
      const savedEnt = {
        ...this.addForm,
        ent_name: this.addForm.ent_name.trim()
      }
      try {
        const res = await api.postJson('yn_ent_save', savedEnt)
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        const entId = (res.data && res.data.id) || savedEnt.id
        if (!entId) {
          this.$message.error('保存失败，未返回企业 ID')
          return
        }
        if (res.data && res.data.ent_code) savedEnt.ent_code = res.data.ent_code
        this.showAdd = false
        this.addForm = emptyAddForm()
        this.keyword = savedEnt.ent_name || this.keyword
        await this.search()
        const created = this.list.find(x => x.id === entId) || { id: entId, ...savedEnt }
        await this.onPick(created)
        this.tab = isEdit ? 'basic' : 'sites'
        this.syncEntTableCurrent()
        this.$message.success(isEdit ? '企业信息已保存' : '企业已保存，请维护点位项目')
      } finally {
        this.addSaving = false
      }
    },
    async confirm() {
      if (!this.current) return
      this.confirmSaving = true
      try {
        const ent = {
          ...this.current,
          sites: this.sites
        }
        this.$emit('select', ent)
        if (this.siteImportEnabled) {
          let picked = this.selectedSites
          if (!picked.length && this.sites.length && this.allowImportFallback) {
            picked = [...this.sites]
          }
          const rows = picked.map(site => siteToMonitorItem(site, {
            typeInferConfig: this.effectiveTypeInfer,
            typeConfig: this.effectiveTypeConfig,
            freqPresets: this.effectiveFreqPresets,
            isRoutine: this.isRoutine
          }))
          this.$emit('import-items', rows)
        }
        this.visible = false
      } finally {
        this.confirmSaving = false
      }
    },
    pickSite(row) {
      this.$emit('pick-site', { ...row, ent_id: this.current ? this.current.id : null })
    }
  }
}
</script>

<style scoped>
.list-group { margin-bottom: 0; }
.list-group-item { cursor: pointer; }
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  background-color: #e8f4fc;
  border-color: #ddd;
  color: inherit;
  z-index: auto;
}
.ent-list-toolbar {
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 30px;
  margin-bottom: 10px;
}
.ent-list-search {
  flex: 1;
  min-width: 0;
  position: relative;
}
.ent-list-sort {
  width: 128px;
  flex-shrink: 0;
}
.ivan-ent-basic {
  position: relative;
  padding-top: 2px;
}
.ivan-ent-label { display: inline-block; min-width: 70px; }
.ent-edit-form { margin-bottom: 0; }
.empty-tab { color: #909399; padding: 24px; text-align: center; }
.site-tab-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.site-year-label { font-size: 12px; color: #606266; }
.site-tab-hint { font-size: 12px; color: #909399; }
.site-hint { font-size: 12px; color: #909399; margin-top: 6px; }
.danger-link { color: #c00 !important; }
.history-panel { padding-bottom: 4px; }
.history-block-title {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin: 8px 0 6px;
}
.history-empty { padding: 12px; }
.site-item-actions { display: flex; align-items: center; gap: 12px; margin-top: 4px; }
.site-item-count { font-size: 12px; color: #909399; }
.cma-filter-row { margin-bottom: 8px; }
.cma-toolbar { display: flex; align-items: center; gap: 10px; margin: 8px 0; font-size: 12px; }
.cma-stat { color: #606266; flex: 1; }
.cma-pager { margin-top: 8px; text-align: right; }

/* 嵌套 Element 弹窗压过选择企业 modal（1050） */
body > .v-modal {
  z-index: 2990 !important;
}
body > .el-dialog__wrapper {
  z-index: 3000 !important;
}
</style>

<style>
/* 对齐 Ivan showWin(full) Bootstrap modal
   z-index 用 Bootstrap 默认档，保证 Element 子弹窗（≥2000）能盖在上面 */
.ivan-ent-backdrop {
  z-index: 1040 !important;
  opacity: 0.5;
}
.ivan-ent-modal {
  z-index: 1050 !important;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: center;
}
.ivan-ent-modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}
.ivan-ent-modal .modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
.ivan-ent-modal .modal-content {
  overflow: hidden;
  border-radius: 6px;
}
.ivan-ent-modal .modal-header {
  border-bottom: 1px solid #e5e5e5;
}
.ivan-ent-modal .modal-footer {
  border-top: 1px solid #e5e5e5;
  text-align: right;
}
.ivan-ent-modal .modal-footer .btn {
  margin-left: 5px;
}
.ivan-ent-modal .modal-footer .btn i {
  margin-right: 4px;
}
.ivan-ent-modal .nav-tabs > li > a {
  padding: 5px 10px;
  outline: none !important;
  box-shadow: none !important;
}
.ivan-ent-modal .nav-tabs > li > a:focus,
.ivan-ent-modal .nav-tabs > li > a:active {
  outline: none !important;
  box-shadow: none !important;
}
.ivan-ent-modal .divider-v {
  height: 100%;
  width: 10px;
  background-color: #e9f0f5;
}

/* 二级窗：对齐 Ivan showWin(width) — 头/底固定，body 限高滚动 */
.ivan-sub-win {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1060;
}
.ivan-sub-backdrop {
  z-index: 1060 !important;
  opacity: 0.5;
}
.ivan-sub-modal {
  z-index: 1070 !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.ivan-sub-modal .modal-content { overflow: hidden; }
.ivan-sub-modal .modal-footer .btn { margin-left: 5px; }
.ivan-sub-modal .modal-footer .btn i { margin-right: 4px; }
body > .v-modal { z-index: 1080 !important; }
body > .el-dialog__wrapper { z-index: 1090 !important; }
</style>